'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
var InternalRadio_web = require('../../internal/InternalRadio/InternalRadio.web.cjs');
require('../Typography/Typography.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var Radio_web_styles = require('./Radio.web.styles.cjs');

/**
 * A radio component for selecting a single option from a list.
 *
 * {@link https://aviary.fullscript.io/latest/components/template/web-sxbFrIai | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Radio/Radio.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Radio = ({ children, alignment = "center", customCss, ...rest })=>{
    const labelStyles = alignment === "top" && Radio_web_styles.topAlignment;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalRadio_web.InternalRadio, {
        "data-testid": "aviary-radio",
        css: customCss,
        labelStyle: labelStyles,
        ...rest,
        children: children
    });
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.web.cjs.map
